
import { getUrlParameter } from "../utils/getUrlParameter";
import { mobileAndTabletcheck } from "../utils/mobileAndTabletCheck";
import { parseQueryString } from "../utils/urlUtils";
import { getCookie } from "../utils/cookiesUtils";
import { WebChatOptions } from "../WebChatOptions";
import { WebChatState } from "../WebChatContext";

var platform = require('platform');


export function buildAuthorizationDto(mergedOptions: WebChatOptions, currentState: WebChatState) {
   
    // const mergedOptions = druidWebChatState.mergedChatOptions;

    var authorizationDto: Partial<{
        botId: Nullable<string>,
        userId: string,
        conversationToken: string,
        queryString: string,
        userLanguage: string,
        otherServicesEndpointIndex: number,
        flowId: Nullable<string>,
        isFormChannel: Nullable<boolean>,
        isSecondaryChannel: Nullable<boolean>
    }> = {};
    authorizationDto.botId = mergedOptions.botId;
    // authorizationDto.isExternalLoggedIn = mergedOptions.isLoggedIn; // TODO
    authorizationDto.userLanguage = /*getCookie(mergedOptions.conversationToken_namePrefix || "" + 'druidConversationLanguage');*/ currentState.locale;

   
    var builtQueryParams = "";

    builtQueryParams = mergedOptions.queryParams || "";

    var toAddQueryParams: String[] = [];
    toAddQueryParams.push(`isMobile=${mobileAndTabletcheck()}`);
    !mergedOptions._disableAutoForwardCurrentDocumentQueryString && toAddQueryParams.push(!!window.location.search ? (window.location.search.replace('?', '')) : '');
    // toAddQueryParams.push(`language=${currentState.locale}`);

    if (!!platform) {
        toAddQueryParams.push(...[`OSVersion=${platform.os.family} ${platform.os.version}`, `DeviceModel=${encodeURIComponent(platform.ua)}`, `App=${platform.name}`, `AppVersion=${platform.version}`, `origin=${encodeURIComponent(window.location.origin)}`, `pathName=${encodeURIComponent(window.location.pathname)}`]);
    }

    let parsedReceivedQueryString = parseQueryString(mergedOptions.queryParams);
    if (parsedReceivedQueryString.length) {
        parsedReceivedQueryString.filter(f => !!f).forEach(prqs => {
            try {
                let prqsName = prqs.split("=")[0];
                let allreadyFoundKeyIdx = toAddQueryParams.findIndex(f => f.startsWith(prqsName));

                if (allreadyFoundKeyIdx >= 0 && (prqs.startsWith('OSVersion') || prqs.startsWith('DeviceModel') || prqs.startsWith('App') || prqs.startsWith('AppVersion'))) {
                    toAddQueryParams[allreadyFoundKeyIdx] = prqs;
                }
            } catch (ex) {

            }
        });
    }

    builtQueryParams += (!!builtQueryParams ? '&' : '') + toAddQueryParams.filter(f => !!f).join("&");

    var druidConversationToken: Nullable<string> = "";
    if(currentState.conversationToken) {
        druidConversationToken = currentState.conversationToken;
    } else {
        if (!!getUrlParameter(mergedOptions.conversationToken_namePrefix + "druidConversationToken")) {
            druidConversationToken = getUrlParameter(mergedOptions.conversationToken_namePrefix + "druidConversationToken");
        } else {
            if (getUrlParameter('Source').split('---').length > 1) {
                druidConversationToken = getUrlParameter('Source').split('---')[1];
                builtQueryParams = builtQueryParams.replace(`---${druidConversationToken}`, '');
            }
            else {
                if (!!mergedOptions.conversationTokenEnabled || getCookie(mergedOptions.conversationToken_namePrefix + "druidConversationToken")) {
                    druidConversationToken = getCookie(mergedOptions.conversationToken_namePrefix + "druidConversationToken");
                }
            }
        }
    }
    
    if (!!druidConversationToken) {
        authorizationDto.conversationToken = mergedOptions._requestNewConversationToken === true ? "new_conversationtoken" : druidConversationToken;
    }

    authorizationDto.otherServicesEndpointIndex = mergedOptions.otherServicesEndpointIndex;
    authorizationDto.userId = "anonymous";
    authorizationDto.queryString = builtQueryParams;
    authorizationDto.isSecondaryChannel = mergedOptions._isSecondaryChannel;
    
    authorizationDto.flowId = mergedOptions.flowId;
    authorizationDto.isFormChannel = mergedOptions.isFormChannel;

    return authorizationDto;

}